import { Icon } from '@monash/portal-react';
import { lightOrDark } from '@/components/pages/custom/widget-library/utils';
import c from './colour-list.module.scss';
import { useArrowKeyFocusing } from '../../../../../../../hooks/use-arrow-key-focusing';

const ColourList = ({
  selectedColour,
  onSelect,
  screenReaderPrefix = 'Colour',
  colours,
}) => {
  const getContrastColour = (value) => {
    const colour = value.startsWith('var') // Get colour value of items using CSS variables
      ? getComputedStyle(document.documentElement).getPropertyValue(
          value.replace(/var\((--.*?)\)/, '$1') // regex to extract variable name from var(--x) format
        )
      : value;

    return lightOrDark(colour) === 'light' ? '#333333' : '#FFFFFF';
  };

  const { parentRef, moveFocus, focusedIndex } = useArrowKeyFocusing({
    focusableItemsSelector: '[data-focusable]',
  });

  return (
    <ul
      className={c.colourPalette}
      role="radiogroup"
      ref={parentRef}
      onKeyUp={moveFocus}
    >
      {colours.map((item, index) => {
        const isSelected = item.id === selectedColour;
        const contrastColour = getContrastColour(item.value);
        const screenReaderLabel = `${screenReaderPrefix}: ${item.id}`;

        return (
          <li key={item.value}>
            <button
              className={c.colourSquare}
              type="button"
              // TODO: come up with styling for 'auto' option
              style={{
                backgroundColor: item.value,
                borderColor: item.id === 'white' && 'var(--card-border-color)',
                outlineColor: contrastColour,
              }}
              onClick={() => onSelect(item.id)}
              role="radio"
              aria-label={screenReaderLabel}
              tabIndex={focusedIndex === index ? 0 : -1}
              data-focusable
              aria-checked={isSelected}
            >
              {!isSelected && item.text && (
                <span style={{ color: item.text }}>Aa</span>
              )}
              {isSelected && <Icon.Check color={contrastColour} />}
            </button>
          </li>
        );
      })}
    </ul>
  );
};
export default ColourList;
